export default "__VITE_ASSET__CKqGfFoQ__"